import { render, staticRenderFns } from "./data_table.vue?vue&type=template&id=f65b23e0&scoped=true&"
import script from "./data_table.vue?vue&type=script&lang=js&"
export * from "./data_table.vue?vue&type=script&lang=js&"
import style0 from "./data_table.vue?vue&type=style&index=0&id=f65b23e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65b23e0",
  null
  
)

export default component.exports